<template>
  <ProductionOrderStepFormEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-if="!mountAgain"
      :enabled-submit="enabledSubmit"
  />
</template>
<script>
import productionOrderStepFormEmbeddableMixin from "@/mixins/embeddable/production/productionOrderStepFormEmbeddableMixin";

export default {
  name: 'ProductionOrderStepForm',
  mixins: [productionOrderStepFormEmbeddableMixin],
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {
        //Será chamado uma única vez após default
    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onBeforeSubmit() {

      //Libera a continuidade sem nenhuma condição especial
      this.enabledSubmit = true
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()


  },
}
</script>
